import { useState, useEffect } from "react";
import Product from "../actions/purchaseProduct";
import Controls from "./controls/Controls";
import useTable from "./customHelpers/useTable";
import { TableBody, TableCell, TableRow } from "@mui/material";
const SaveFromFile = (props) => {
  const { viewAllProducts } = Product();
  const { addProductFromFile } = Product();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const updatedColDefs = [
    ...props.file.colDefs,
    { id: "status", label: "Status" },
  ];
  const filteredData = props.file.data.filter((item) =>
    Object.values(item).some((value) => value)
  );

  const { TblContainer, TblHead } = useTable(
    filteredData.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0
    ),
    updatedColDefs,
    filterFn
  );
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (filteredData) {
      const { total, quantity } = filteredData.reduce(
        (acc, item) => {
          const price =
            parseFloat(
              item.price?.toString().replace(/\s+/g, "").replace(/,/g, "")
            ) || 0;
          const qty =
            parseInt(item.quantity?.toString().replace(/\s+/g, ""), 10) || 0;
          acc.total += price * qty;
          acc.quantity += qty;
          return acc;
        },
        { total: 0, quantity: 0 }
      );
      setTotalPrice(total);
      setTotalQuantity(quantity);
    }
  }, [filteredData]);
  useEffect(() => {
    getExistingAllProducts();
  }, []);
  const handleSubmit = () => {
    addProductFromFile(filteredData, props.purchaseOrderId).then((data) => {
      if (data.err) {
        props.NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        props.NotifyMessage({
          message: "Products Added",
          type: "success",
        });
        props.setOpenPopupBulkSave(false);
        props.getAllProducts();
      }
    });
  };
  const getExistingAllProducts = () => {
    viewAllProducts(props.purchaseOrderId).then((data) => {
      if (data.products) {
        setProducts(data.products);
      }
    });
  };
  const hasNotAllowed = filteredData.some((item) => {
    const existingProduct = products.find((prod) => prod.sku === item.sku);
    return existingProduct?.status === "IN-Inventory";
  });
  return (
    <div>
      <TblContainer>
        <TblHead />
        <TableBody>
          {filteredData.map((item, index) => {
            if (!item.name) return null;

            const existingProduct = products.find(
              (prod) => prod.sku === item.sku
            );
            let status = "New";
            if (existingProduct) {
              if (existingProduct.status === "IN-Inventory") {
                status = "Not Allowed";
              } else {
                status = "Updated";
              }
            }

            return (
              <TableRow key={index}>
                {updatedColDefs.map((col, colIndex) => {
                  return (
                    <TableCell key={colIndex}>
                      {col.id === "status" ? (
                        <span
                          style={{ color: status === "New" ? "green" : "red" }}
                        >
                          {status}
                        </span>
                      ) : item[col.id] && item[col.id].length > 10 ? (
                        item[col.id].substring(0, 10) + "..."
                      ) : (
                        item[col.id]
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </TblContainer>
      <Controls.Button text="Submit" onClick={handleSubmit} />
      <div style={{ marginTop: 20 }}>
        <strong>Total Price: </strong>
        {totalPrice.toFixed(2)}
        <br />
        <strong>Total Quantity: </strong>
        {totalQuantity}
        <br />
        {hasNotAllowed && (
          <>
            <strong>Not Allowed: </strong>
            Under the same purchase order (PO), it’s not allowed to add a
            product with the same SKU which is already published to the
            inventory. Try with a different PO.
          </>
        )}
      </div>
    </div>
  );
};

export default SaveFromFile;
